import React from 'react'

export default function Loader() {
  return (
    <div className="loading-wave">
  <div className="loading-bar" />
  <div className="loading-bar" />
  <div className="loading-bar" />
  <div className="loading-bar" />
</div>

  );
}
